import React from "react";

import Heading from "./components/common/Heading";
import HSL from "./components/HSL";
import Footer from "./components/common/Footer";

function App() {
  return (
    <>
      <Heading text="Colors" />
      <HSL />
      <Footer />
    </>
  );
}

export default App;
